import { useEffect, useState } from "react";
import type { Message } from "../../common/types/Message";
import { queryLatestMessage } from "../../FirebaseBackend";
import { listenToQueryToState } from "../../FirebaseListenerToState";
import { Flex } from "../Common/Flex";
import Label from "../Common/Label";

function RequestStatusChatBadge({
    conversation,
    request,
}: {
    conversation: string;
    request?: string | undefined;
}) {
    const [latestMessages, setLatestMessages] = useState<Message[] | undefined>();
    const latestMessage = latestMessages ? latestMessages[0] : undefined;

    useEffect(() => {
        const queryLastMessageInRequest = queryLatestMessage(conversation, request);

        return listenToQueryToState<Message>(
            queryLastMessageInRequest,
            setLatestMessages,
        );
    }, [conversation, request]);

    const latestMessageFromMember = latestMessage && !latestMessage.sentByAgent;

    if (!latestMessageFromMember) {
        return null;
    }

    return (
        <div className="pt-4! pb-4!">
            <Flex.Column gap="medium" alignItems="center">
                <Label.Large.SemiBold>Thank you for your message</Label.Large.SemiBold>
                <Label.Medium.N50>
                    A member of your team will get back to you shortly
                </Label.Medium.N50>
            </Flex.Column>
        </div>
    );
}

export default RequestStatusChatBadge;
